import { render, staticRenderFns } from "./person.vue?vue&type=template&id=1beed196"
import script from "./person.vue?vue&type=script&lang=js"
export * from "./person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1beed196')) {
      api.createRecord('1beed196', component.options)
    } else {
      api.reload('1beed196', component.options)
    }
    module.hot.accept("./person.vue?vue&type=template&id=1beed196", function () {
      api.rerender('1beed196', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bet-panel/bet-zone/person.vue"
export default component.exports